import { createSelector } from '@ngrx/store';

import { authFeature } from '../auth.feature';

const { selectSso } = authFeature;

export { selectSso };

export const selectSsoIsCheckingEmail = createSelector(
  selectSso,
  (sso) => sso.isCheckingEmail,
);
export const selectSsoIsExchangingCode = createSelector(
  selectSso,
  (sso) => sso.isExchangingCode,
);
export const selectSsoEmail = createSelector(selectSso, (sso) => sso.email);
export const selectSsoOidcConfig = createSelector(
  selectSso,
  (sso) => sso.oidcConfig,
);
export const selectSsoError = createSelector(selectSso, (sso) => sso.error);
